const arraysData = function(arrayA, arrayB) {
  return {
    same: intersection(arrayA, arrayB),
    added: difference(arrayA, arrayB),
    removed: difference(arrayB, arrayA)
  };
};

const intersection = function(arrayA, arrayB) {
  return arrayA.filter(x => arrayB.includes(x));
};

const difference = function(arrayA, arrayB) {
  return arrayA.filter(x => !arrayB.includes(x));
};

export default arraysData;
